const { default: styled } = require('styled-components');

export const DownloadContainer = styled.div`
	display: flex;
	align-items: center;
	flex-direction: column;
	width: 100%;
	background-color: #f0f0f0; /* light grey background */
	padding: 16px;
	border: 1px solid #ccc; /* grey border */
`;

export const Icon = styled.svg`
	width: 100px;
	height: 100px;
	fill: #28a745; /* green color */
	margin-right: 12px;
`;

export const Message = styled.p`
	color: #333; /* dark grey text */
	font-size: 16px;
	margin: 0;
	margin-top: 20px;
`;
